<template>
  <div>
    <!-- Add FloatingActionBar for bulk actions -->
    <FloatingActionBar
      :selected="selected"
      :totalItems="totalItems"
      :showDeleteSelected="true"
      :show-assign="false"
      :showDeleteAll="false"
      :showUpdateStatus="false"
      :showSelectAll="false"
      @delete-selected="handleShowDialogDelete"
    />
    <ActitiveTabcomponent :tabs="mainTabs" :defaultTab="'list'">
      <template #tab-buttons>
        <div
          class="justify-end items-center"
          :class="[$vuetify.breakpoint.lgAndUp ? 'flex justify-end' : 'flex-col']"
        >
          <v-btn
            @click="showAddNewPartner()"
            :color="$vuetify.theme.currentTheme.primary"
            :class="[
              $vuetify.breakpoint.lgAndUp ? ' normal-case white--text' : ' flex-col white--text '
            ]"
            v-show="canWrite"
          >
            <v-icon left dark>mdi-plus</v-icon>
            Add
          </v-btn>
        </div>
      </template>

      <template #list>
        <div class="overflow-x-auto overflow-y-auto pt-2">
          <v-data-table
            :headers="headers"
            :items="partners"
            class="table-radius border border-[#e0e0e0]"
            :options.sync="options"
            :footer-props="{ itemsPerPageOptions: [5, 10, 15, 30] }"
            :server-items-length="totalItems"
            :loading="loadTable"
            fixed-header
            v-model="selected"
            show-select
            item-key="_id"
          >
            <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
              <p
                :key="index"
                class="font-title"
                v-if="header.text?.length > 15"
                v-tooltip="{ text: header.text }"
              >
                {{ header.text }}
              </p>
              <p :key="index" v-else class="font-title">{{ header.text }}</p>
            </template>
            <template v-slot:item.partnerName="{ item }">
              <td class="px-4 py-3 table-font">{{ item.partnerName }}</td>
            </template>
            <template v-slot:item.partnerDescription="{ item }">
              <td class="px-4 table-font">{{ item.partnerDescription }}</td>
            </template>
            <template v-slot:item.partnerLocation="{ item }">
              <td class="px-4 table-font">
                {{ item.partnerLocation ? Object.values(item.partnerLocation).join(', ') : '' }}
              </td>
            </template>
            <template v-slot:item.partnerStatus="{ item }">
              <td
                :class="getPartnerStatusClr(item.partnerStatus)"
                class="px-4 table-font font-weight-medium"
              >
                {{ titleCase(item.partnerStatus) }}
              </td>
            </template>
            <template v-slot:item.action="{ item }">
              <td class="px-4 table-font">
                <action-button
                  :item="item"
                  :canEdit="canEdit"
                  :canDelete="canDelete"
                  :handleEdit="() => partnerEdit(item)"
                  :handleDelete="() => partnerDelete(item)"
                  :showDeleteButton="true"
                />
              </td>
            </template>
          </v-data-table>
        </div>
      </template>
    </ActitiveTabcomponent>

    <v-dialog v-model="showAddPartner" width="800px">
      <div>
        <!-- add edit partner will come here -->
        <AddEditPartner
          :key="addEditPartnerKey"
          :partnerData="selectedPartnerData"
          @partner-saved="toggleShowTable"
          @closeDialog="closeAddEditDialog"
        />
      </div>
    </v-dialog>
    <!-- <v-dialog v-model="openBrands" max-width="600" persistent>
     
      <v-dialog v-model="openBrands" max-width="600" persistent>
        <GenericBulkUpload
          ref="bulkUploader"
          title="Bulk Upload Products"
          subtitle="Upload multiple products using Excel file"
          :entityName="'Product'"
          :requiredColumns="['SL No.', 'product', 'productMarker']"
          @save-button-visibility="handleSaveButtonVisibility"
          :sampleData="[
            { 'SL No.': 1, product: 'Product 1', productMarker: 'Marker 1' },
            { 'SL No.': 2, product: 'Product 2', productMarker: 'Marker 2' }
          ]"
          uploadEndpoint="/brandMapping/bulk"
          method="post"
          successKey="mappingCreatedSuccessfully"
          :enableSave="false"
          :controlParentSaveButton="true"
          failedKey="mappingCreationFailed"
          invalidItemsKey="invalidMapping"
          @close="closeUpload"
        />
      </v-dialog>
    </v-dialog> -->
    <!-- Add AlertPopUp for delete confirmation -->
    <AlertPopUp
      :showConfirmationDialog="showDeleteDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="`Do you want to delete selected partners?`"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="partnerDeleteFunc"
      :cancel="handleShowDialogDelete"
      :loading="loading"
    />
  </div>
</template>

<script>
import ActionButton from '../../ActionButton.vue'
import { debounce, hasPermission, convertToTitleCase } from '@/utils/common'
import permissionData from '@/utils/permissions'
import GenericBulkUpload from '../CollectionManagement/GenericBulkUpload.vue'
import UploadProducts from './uploadProducts.vue'
import AddEditPartner from './AddEditPartner.vue'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import FloatingActionBar from '@/components/Workforce/CollectionManagement/CaseModules/FloatingActionBar.vue'
import AlertPopUp from '@/components/AlertPopUp.vue'
import { axiosUrl } from '@/utils/workforceApi.js'

export default {
  name: 'InventoryIn',
  components: {
    ActionButton,
    ActitiveTabcomponent,
    // UploadProducts,
    // GenericBulkUpload,
    AddEditPartner,
    FloatingActionBar,
    AlertPopUp
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      partners: [],
      showTable: true,
      loadTable: true,
      options: { itemsPerPage: 10, page: 1 },
      totalItems: 0,
      filterPartner: '',
      showAddPartner: false,
      selectedPartnerData: null,
      openBrands: false,
      addEditPartnerKey: 0, // Key to force re-rendering of AddEditPartner component
      selected: [], // For checkbox selection
      showDeleteDialog: false, // For delete confirmation dialog
      loading: false // For loading state during delete
    }
  },
  beforeCreate() {
    this.debouncedFetchPartners = () => {}
  },
  created() {
    this.debouncedFetchPartners = debounce(this.fetchPartners, 500)
  },
  watch: {
    options: {
      handler() {
        this.fetchPartners()
      },
      deep: true
    },
    '$route.query.search': {
      handler(newQuery) {
        try {
          this.filterPartner = newQuery || ''
          this.options.page = 1
          this.debouncedFetchPartners()
        } catch (error) {
          console.log(error)
        }
      },
      immediate: true
    },
    '$route.query.partner': {
      handler(partner) {
        try {
          this.filterPartner = partner
          this.options.page = 1
          this.debouncedFetchPartners()
        } catch (error) {
          console.log(error)
        }
      },
      immediate: true
    },
    filterPartner(val) {
      if (!val && this.$route.query.search) {
        this.$router.replace({ query: {} }).catch((err) => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    }
  },
  computed: {
    mainTabs() {
      const tabs = []
      return tabs
    },
    headers() {
      const headers = [
        { text: 'Lender', value: 'partnerName', sortable: false, width: '30%' },
        { text: 'Descrption', value: 'partnerDescription', sortable: false, width: '30%' },
        { text: 'Status', value: 'partnerStatus', sortable: false, width: '30%' },
        this.canEdit ? { text: 'Action', value: 'action', sortable: false } : []
      ]
      return headers
    },
    canEdit() {
      return hasPermission(this.userData, permissionData.inventoryEdit)
    },
    canWrite() {
      return hasPermission(this.userData, permissionData.inventoryWrite)
    },
    canDelete() {
      return hasPermission(this.userData, permissionData.inventoryDelete)
    }
  },
  methods: {
    closeAddEditDialog() {
      this.showAddPartner = false
    },
    uploadBrands() {
      this.openBrands = true
    },
    closeUpload() {
      this.openBrands = false
    },
    getPartnerStatusClr(status) {
      const statuses = {
        ACTIVE: 'text-green-500',
        IN_ACTIVE: 'text-red-500'
      }

      return statuses[status]
    },
    titleCase(str) {
      return convertToTitleCase(str)
    },
    toggleShowTable() {
      this.showAddPartner = false
      this.showTable = true
      this.selectedPartnerData = null
      this.fetchPartners()
    },
    toggleshowAddPartner() {
      this.showTable = false
      this.showAddPartner = true
    },
    async fetchPartners() {
      try {
        const { page, itemsPerPage } = this.options
        const params = {
          page,
          limit: itemsPerPage > -1 ? itemsPerPage : this.totalItems
        }
        if (this.filterPartner) {
          params.search = this.filterPartner
        }
        this.loadTable = true
        // Using the axiosUrl constant instead of hardcoded URL
        const response = await this.$axios.get(axiosUrl.partners.getPartners, {
          params
        })
        this.loadTable = false
        this.partners = response.data.partners
        this.totalItems = response.data.pagination?.totalCount
      } catch (error) {
        console.error('An error occurred:', error)
      }
    },
    partnerEdit(item) {
      this.selectedPartnerData = item
      this.addEditPartnerKey += 1 // Force re-rendering
      this.toggleshowAddPartner()
    },
    showAddNewPartner() {
      // Explicitly reset the selected data when adding a new partner
      this.selectedPartnerData = {}
      this.addEditPartnerKey += 1
      this.toggleshowAddPartner()
    },
    partnerDelete(item) {
      // Set the selected item for deletion and show confirmation dialog
      this.selected = [item]
      this.handleShowDialogDelete()
    },
    handleShowDialogDelete() {
      this.showDeleteDialog = !this.showDeleteDialog
    },
    async partnerDeleteFunc() {
      this.loading = true
      try {
        const deletePromises = this.selected.map((item) =>
          this.$axios.delete(`${axiosUrl.partners.getPartners}/${item._id}`)
        )

        await Promise.all(deletePromises)

        this.$toast.success(`${this.selected.length} partner(s) deleted successfully`)
        this.selected = []
        this.fetchPartners()
      } catch (error) {
        console.error('Error deleting partners:', error)
        this.$toast.error('Failed to delete partner(s)')
      } finally {
        this.loading = false
        this.handleShowDialogDelete()
      }
    },

    handleInput: debounce(function () {
      this.options.page = 1

      if (this.filterPartner) {
        this.$router
          .push({
            path: this.$route.path,
            query: { ...this.$route.query, search: this.filterPartner }
          })
          .catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
              console.error('Navigation error:', err)
            }
          })
      } else {
        // Clear query when filter is empty
        const query = { ...this.$route.query }
        delete query.search
        this.$router.replace({ query }).catch((err) => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err)
          }
        })
      }
      this.fetchPartners()
    }, 1000)
  }
}
</script>

<style scoped>
.col {
  padding: 0px !important;
}
.v-simple-checkbox {
  padding: 16px;
}
.v-input--selection-controls__ripple {
  margin: 0px !important;
}
.v-data-table >>> .v-data-table__wrapper > table > tbody > tr > td > .v-data-table__checkbox {
  text-align: center;
}
.font-title {
  font-size: 0.875rem;
  color: #000;
  margin-bottom: 0px !important;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-radius {
  border-radius: 0px !important;
}

/* .v-data-table >>> .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.875rem;
  color: #000 !important;
} */
/* .table-font {
  font-size: 0.8rem !important;
} */
</style>
